import { render } from "./DashboardFreemium.vue?vue&type=template&id=153e282a"
import script from "./DashboardFreemium.vue?vue&type=script&lang=js"
export * from "./DashboardFreemium.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__